export default "__VITE_ASSET__DPBL96Ac__"